import _toConsumableArray from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _assertThisInitialized from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _inherits from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _defineProperty from "/home/vsts/work/1/s/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var __jsx = React.createElement;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable no-unused-vars */
/**
 * Represents Location Finder.
 * @author shivam
 */import React, { Component } from 'react';
import styled from 'styled-components';
import styles from './LocationFinder.style';
import { formLabels } from '../../../constants/labels/en';
import { findLocations, fetchStatesList, fetchCoordinates } from '../../../utils/formUtility';
import analyticsConstants from '../../../constants/analyticsConstants';
import Form from '../Form';
import Button from '../../atoms/Button';
import Heading from '../../atoms/Heading';
import Pagination from '../../molecules/Pagination';
import LocationResultItem from './LocationResultItem';
import { LocationFinderLabels } from '../../../constants/labels/en';
import { scrollPageTo } from '../../../utils/utilityFunction';
import AccordionList from './AccordionList';
import { BUSINESS_TYPES, LOCATION_BUSINESS_TYPES, LOCATION_RESULT_PAGE_SIZE } from '../../../constants/globalConstants';
var LocationFinderForm = /*#__PURE__*/function (_Component) {
  _inherits(LocationFinderForm, _Component);
  var _super = _createSuper(LocationFinderForm);
  function LocationFinderForm(props) {
    var _this;
    _classCallCheck(this, LocationFinderForm);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "submitFormManually", function (e) {
      var numberPattern = /[0-9]*$/g;
      var pagenum = '';
      if (e) {
        e.preventDefault();
        pagenum = e ? e.target.href : '';
        _this.isPagination = e.target.hasAttribute('href');
      }
      pagenum = pagenum.match(numberPattern);
      _this.setState({
        pageNumber: parseInt(pagenum[0] || 1)
      }, function () {
        if (_this.submitMyForm) {
          _this.submitMyForm(e);
        }
      });
    });
    _defineProperty(_assertThisInitialized(_this), "bindFormikSubmit", function (submitForm) {
      _this.submitMyForm = submitForm;
    });
    _this.submitLocationFinderForm = _this.submitLocationFinderForm.bind(_assertThisInitialized(_this));
    _this.successCallback = _this.successCallback.bind(_assertThisInitialized(_this));
    _this.failureCallback = _this.failureCallback.bind(_assertThisInitialized(_this));
    _this.statesListSuccessHandler = _this.statesListSuccessHandler.bind(_assertThisInitialized(_this));
    _this.statesListErrorHandler = _this.statesListErrorHandler.bind(_assertThisInitialized(_this));
    _this.handlePostalCodeChange = _this.handlePostalCodeChange.bind(_assertThisInitialized(_this));
    _this.handleStateChange = _this.handleStateChange.bind(_assertThisInitialized(_this));
    _this.handleBusinessTypeChange = _this.handleBusinessTypeChange.bind(_assertThisInitialized(_this));
    _this.submitFormManually = _this.submitFormManually.bind(_assertThisInitialized(_this));
    _this.coordinatesSuccessCallback = _this.coordinatesSuccessCallback.bind(_assertThisInitialized(_this));
    _this.coordinatesFailureCallback = _this.coordinatesFailureCallback.bind(_assertThisInitialized(_this));
    _this.pageSize = LOCATION_RESULT_PAGE_SIZE;
    _this.businessType = [LOCATION_BUSINESS_TYPES['GENERAL_PRACTICE'].value, LOCATION_BUSINESS_TYPES['PET_RESORTS_BARK_SIDE'].value, LOCATION_BUSINESS_TYPES['PET_RESORTS_PETSUITES'].value, LOCATION_BUSINESS_TYPES['SPECIALTY_ER'].value, LOCATION_BUSINESS_TYPES['SPECIALTY_+_ER'].value, LOCATION_BUSINESS_TYPES['PET_RESORTS'].value, LOCATION_BUSINESS_TYPES['EQUINE'].value];
    _this.state = {
      statesList: [],
      errorFetchingStates: false,
      searchResults: {},
      coordinatesResults: {},
      errorFetchingResults: false,
      errorFetchingCoordinateResults: false,
      pageNumber: 1,
      isSubmitting: false,
      shouldHideForm: false,
      toggleMapText: '',
      shouldHideMap: false,
      shouldHideList: false,
      selectedState: '',
      selectedPostal: ''
    };
    _this.submitMyForm = null;
    _this.isPagination = false;
    return _this;
  }
  _createClass(LocationFinderForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      // get yext id's from the "single input" field in contentful
      // const { yextSearchApi } = this.props;
      // const params = {
      //   successCallback: this.statesListSuccessHandler,
      //   failureCallback: this.statesListErrorHandler,
      //   yextSearchApi
      // };
      // fetchStatesList(params);
      // const coordinatesParams = {
      //   successCallback: this.coordinatesSuccessCallback,
      //   failureCallback: this.coordinatesFailureCallback,
      //   yextSearchApi,
      //   businessType: this.props.nvaSite.SiteBusinessType || '',
      //   themeName: this.props.nvaSite.ThemeName
      // };
      // fetchCoordinates(coordinatesParams);
      // this.submitFormManually();
    }
  }, {
    key: "resetPageNumber",
    value: function resetPageNumber() {
      this.setState({
        pageNumber: 1
      });
    }
  }, {
    key: "handleBusinessTypeChange",
    value: function handleBusinessTypeChange(event, _ref) {
      var setFieldValue = _ref.setFieldValue;
      var target = event.currentTarget;
      var targetValue = target.value;
      this.resetPageNumber();
      if (target.checked) {
        this.businessType.push(targetValue);
      } else {
        this.businessType.splice(this.businessType.indexOf(targetValue), 1);
      }
      setFieldValue('businessType', this.businessType);
    }
  }, {
    key: "handleStateChange",
    value: function handleStateChange(event) {
      this.setState({
        pageNumber: 1,
        selectedState: event.target.value,
        selectedPostal: ''
      });
    }
  }, {
    key: "handlePostalCodeChange",
    value: function handlePostalCodeChange(event, _ref2) {
      var setFieldValue = _ref2.setFieldValue;
      setFieldValue('state', '');
    }
  }, {
    key: "statesListSuccessHandler",
    value: function statesListSuccessHandler(statesData) {
      var statesList = [];
      statesData.forEach(function (_ref3) {
        var states = _ref3.states;
        statesList.push.apply(statesList, _toConsumableArray(states));
      });
      this.setState({
        statesList: statesList
      });
    }
  }, {
    key: "statesListErrorHandler",
    value: function statesListErrorHandler(errorFetchingStates) {
      this.setState({
        errorFetchingStates: errorFetchingStates
      });
    }
  }, {
    key: "successCallback",
    value: function successCallback(searchResults) {
      var _this2 = this;
      this.setState({
        searchResults: searchResults,
        isSubmitting: false,
        errorFetchingResults: false
      }, function () {
        _this2.isPagination && scrollPageTo('.location-finder-results');
        _this2.isPagination = false;
      });
    }
  }, {
    key: "failureCallback",
    value: function failureCallback(errorFetchingResults) {
      this.setState({
        errorFetchingResults: errorFetchingResults,
        isSubmitting: false
      });
    }
  }, {
    key: "submitLocationFinderForm",
    value: function submitLocationFinderForm(values) {
      var isPSCorp = this.props.nvaSite.SiteBusinessType == 'NVA Corporate' && this.props.nvaSite.ThemeName == 'PetSuites' ? true : false;
      var yextSearchApi = this.props.yextSearchApi;
      this.setState({
        selectedState: values.state,
        selectedPostal: values.postalCode
      });
      var params = Object.assign({}, values, {
        pageNumber: this.state.pageNumber,
        pageSize: isPSCorp ? '50' : this.pageSize,
        successCallback: this.successCallback,
        failureCallback: this.failureCallback,
        yextSearchApi: yextSearchApi,
        XbusinessType: this.props.nvaSite.SiteBusinessType || '',
        themeName: this.props.nvaSite.ThemeName
      });
      var coordinatesParams = Object.assign({}, values, {
        pageNumber: this.state.pageNumber,
        pageSize: this.pageSize,
        successCallback: this.coordinatesSuccessCallback,
        failureCallback: this.coordinatesFailureCallback,
        yextSearchApi: yextSearchApi,
        businessType: this.props.nvaSite.SiteBusinessType || '',
        themeName: this.props.nvaSite.ThemeName
      });
      this.setState({
        isSubmitting: true
      }, function () {
        findLocations(params);
        isPSCorp && fetchCoordinates(coordinatesParams);
      });
    }
  }, {
    key: "coordinatesSuccessCallback",
    value:
    //coordinates
    function coordinatesSuccessCallback(coordinatesResults) {
      this.setState({
        coordinatesResults: coordinatesResults,
        isSubmitting: false,
        errorFetchingCoordinateResults: false
      });
    }
  }, {
    key: "coordinatesFailureCallback",
    value: function coordinatesFailureCallback(errorFetchingCoordinateResults) {
      this.setState({
        errorFetchingCoordinateResults: errorFetchingCoordinateResults,
        isSubmitting: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      /* location form label props */
      var labelProps = {
        className: "nva-location-finder__label location-finder-label"
      };
      /* location form props */
      var locationFormProps = {
        initialValues: {
          state: this.state.selectedState,
          postalCode: this.state.selectedPostal,
          postalCodeField: '',
          //this field is for honey bot
          businessType: this.businessType
        },
        action: '/',
        handleSubmit: this.submitLocationFinderForm,
        validationSchema: ['postalCode', 'businessType']
      };
      /* this field is honey bot */
      var locationFormPostalCodeFieldProps = {
        type: 'text',
        name: 'postalCodeField',
        label: formLabels.LocationFinderForm.HONEY_BOT,
        id: 'postalCodeField',
        ariaLabel: 'enter postal code field',
        autoComplete: 'off'
      };
      /* select props */
      var locationFormStateProps = {
        component: 'select',
        options: this.state.statesList,
        name: 'state',
        label: formLabels.LocationFinderForm.STATE,
        id: 'state',
        onChange: this.handleStateChange,
        ariaLabel: 'enter state field',
        selectedOption: '',
        className: 'col-lg-4 col-md-4 col-xs-12 customMarginBottom',
        placeholder: 'All states/ territories'
      };
      /* input props */
      var locationFormPostalCodeProps = {
        type: 'text',
        name: 'postalCode',
        label: formLabels.LocationFinderForm.POSTAL_CODE,
        id: 'postalCode',
        onChange: this.handlePostalCodeChange,
        ariaLabel: 'enter postal code field',
        className: 'col-lg-4 col-md-4 col-xs-12 postal-code-wrapper customMarginBottom',
        labelProps: labelProps
      };
      /* checkbox props */
      var locationFormBusinessTypeGPProps = {
        name: 'businessType',
        label: LOCATION_BUSINESS_TYPES['GENERAL_PRACTICE'].label,
        id: LOCATION_BUSINESS_TYPES['GENERAL_PRACTICE'].label,
        value: LOCATION_BUSINESS_TYPES['GENERAL_PRACTICE'].value,
        onChange: this.handleBusinessTypeChange,
        className: 'businessTypeCheckbox',
        labelProps: labelProps
      };
      var locationFormBusinessTypePetResortBarkSideProps = {
        name: 'businessType',
        label: LOCATION_BUSINESS_TYPES['PET_RESORTS_BARK_SIDE'].label,
        id: LOCATION_BUSINESS_TYPES['PET_RESORTS_BARK_SIDE'].label,
        value: LOCATION_BUSINESS_TYPES['PET_RESORTS_BARK_SIDE'].value,
        onChange: this.handleBusinessTypeChange,
        className: 'businessTypeCheckbox',
        labelProps: labelProps
      };
      var locationFormBusinessTypePetResortPetSuitesProps = {
        name: 'businessType',
        label: LOCATION_BUSINESS_TYPES['PET_RESORTS_PETSUITES'].label,
        id: LOCATION_BUSINESS_TYPES['PET_RESORTS_PETSUITES'].label,
        value: LOCATION_BUSINESS_TYPES['PET_RESORTS_PETSUITES'].value,
        onChange: this.handleBusinessTypeChange,
        className: 'businessTypeCheckbox',
        labelProps: labelProps
      };
      var locationFormBusinessTypeSpecialtyERProps = {
        name: 'businessType',
        label: LOCATION_BUSINESS_TYPES['SPECIALTY_ER'].label,
        id: LOCATION_BUSINESS_TYPES['SPECIALTY_ER'].label,
        value: LOCATION_BUSINESS_TYPES['SPECIALTY_ER'].value,
        onChange: this.handleBusinessTypeChange,
        className: 'businessTypeCheckbox',
        labelProps: labelProps
      };
      var locationFormBusinessTypeSpecialtyProps = {
        name: 'businessType',
        label: LOCATION_BUSINESS_TYPES['SPECIALTY_+_ER'].label,
        id: LOCATION_BUSINESS_TYPES['SPECIALTY_+_ER'].label,
        value: LOCATION_BUSINESS_TYPES['SPECIALTY_+_ER'].value,
        onChange: this.handleBusinessTypeChange,
        className: 'businessTypeCheckbox',
        labelProps: labelProps
      };
      var locationFormBusinessTypeResortProps = {
        name: 'businessType',
        label: LOCATION_BUSINESS_TYPES['PET_RESORTS'].label,
        id: LOCATION_BUSINESS_TYPES['PET_RESORTS'].label,
        value: LOCATION_BUSINESS_TYPES['PET_RESORTS'].value,
        onChange: this.handleBusinessTypeChange,
        className: 'businessTypeCheckbox',
        labelProps: labelProps
      };
      var locationFormBusinessTypeEquineProps = {
        name: 'businessType',
        label: LOCATION_BUSINESS_TYPES['EQUINE'].label,
        id: LOCATION_BUSINESS_TYPES['EQUINE'].label,
        value: LOCATION_BUSINESS_TYPES['EQUINE'].value,
        onChange: this.handleBusinessTypeChange,
        className: 'businessTypeCheckbox',
        labelProps: labelProps
      };
      var response = this.state.searchResults && this.state.searchResults.response || '';
      var errorFetchingResults = this.state.errorFetchingResults;
      var locationResultResponse = Object.assign({}, response, {
        errorFetchingResults: errorFetchingResults
      });

      // const coordinatesResponse =
      //   (this.state.coordinatesResults &&
      //     this.state.coordinatesResults.response) ||
      //   '';

      // const mapMarkersToClusters =
      //   coordinatesResponse.entities &&
      //   coordinatesResponse.entities.map(marker => {
      //     return {
      //       id: marker.meta.id,
      //       lat: marker.yextDisplayCoordinate.latitude,
      //       lng: marker.yextDisplayCoordinate.longitude,
      //       name: marker.name,
      //       address:
      //         marker.address.line1 + marker.address.city + marker.address.region,
      //       phone: marker.mainPhone,
      //       website: marker.websiteUrl.url
      //     };
      //   });
      // const { errorFetchingCoordinateResults } = this.state;
      // const locationCoordinatesResults = Object.assign({}, coordinatesResponse, {
      //   errorFetchingCoordinateResults
      // });
      // render elements
      //console.log(coordinatesResponse && coordinatesResponse.entities)
      // TODO: Review as it's not being used.
      var ShouldDisplayform = styled.div.withConfig({
        componentId: "sc-108r57z-0"
      })(["", ";"], this.props.nvaSite.SiteBusinessType == 'NVA Corporate' && this.props.nvaSite.ThemeName == 'PetSuites' ? 'display:none' : '');
      return __jsx("div", {
        className: "nva-location-finder ".concat(this.props.className)
      }, __jsx("div", {
        className: "nva-location-finder__results location-finder-wrapper location-finder-results"
      }, __jsx(AccordionList, {
        yextLocationsInformationData: this.props.yextLocationsInformationData,
        customName: this.props.customName
      })));
    }
  }]);
  return LocationFinderForm;
}(Component);
LocationFinderForm.defaultProps = {
  className: '',
  nvaSite: {},
  customName: ''
};
export default styled(LocationFinderForm).withConfig({
  componentId: "sc-108r57z-1"
})(["", ";"], styles);
export { LocationFinderForm as LocationFinderFormVanilla };